// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function () {

	//sticky header after scroll
	var header = document.getElementById('wrapper-navbar');
	var headerHeight = header.offsetHeight;
	var additionalOffset = 150; // Additional scroll distance after header is off-screen
	var offScreenPosition = headerHeight;
	var stickyPosition = offScreenPosition + additionalOffset;

	window.onscroll = function () {
		var scrollPosition = window.scrollY;

		if (scrollPosition > stickyPosition) {
			header.classList.add('sticky-header');
			header.classList.remove('off-screen');
		} else if (scrollPosition > offScreenPosition) {
			header.classList.add('off-screen');
			header.classList.remove('sticky-header');
		} else {
			header.classList.remove('off-screen', 'sticky-header');
		}
	};

	//splide initiating
	var splideElms = document.getElementsByClassName('splide');
	for (var i = 0, len = splideElms.length; i < len; i++) {
		new Splide(splideElms[i]).mount();
	}

	var splideAutoscrollElms = document.getElementsByClassName('splide-autoscroll');
	for (var i = 0, len = splideAutoscrollElms.length; i < len; i++) {
		new Splide(splideAutoscrollElms[i]).mount(window.splide.Extensions);
	}


	//back to top
	// const backToTopButton = document.getElementById('back-to-top');
	//
	// if (backToTopButton) {
	// 	// window.addEventListener('scroll', () => {
	// 	//     if (window.scrollY > 500) { // Shows the button after scrolling down 500px
	// 	//         backToTopButton.style.display = 'block';
	// 	//     } else {
	// 	//         backToTopButton.style.display = 'none';
	// 	//     }
	// 	// });
	//
	// 	backToTopButton.addEventListener('click', (e) => {
	// 		e.preventDefault();
	// 		window.scrollTo({top: 0, behavior: 'smooth'});
	// 	});
	// }

	// Scroll back to top
	var progressPath = document.querySelector('.back-to-top path');
	var pathLength = progressPath.getTotalLength();
	progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
	progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
	progressPath.style.strokeDashoffset = pathLength;
	progressPath.getBoundingClientRect();
	progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';

	var updateProgress = function () {
		var scroll = window.scrollY;
		var height = document.documentElement.scrollHeight - window.innerHeight;
		var progress = pathLength - (scroll * pathLength / height);
		progressPath.style.strokeDashoffset = progress;
	}

	updateProgress();
	window.addEventListener('scroll', updateProgress);

	var offset = 50;
	var duration = 550;

	window.addEventListener('scroll', function () {
		if (window.scrollY > offset) {
			document.querySelector('.back-to-top').classList.add('active-progress');
		} else {
			document.querySelector('.back-to-top').classList.remove('active-progress');
		}
	});

	document.querySelector('.back-to-top').addEventListener('click', function (event) {
		event.preventDefault();
		window.scrollTo({top: 0, behavior: 'smooth'});
	});

	function animateValue(obj, start, end, duration) {
		let startTimestamp = null;

		// Function to format number with commas
		function numberWithCommas(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}

		const step = (timestamp) => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
			obj.innerHTML = numberWithCommas(Math.floor(progress * (end - start) + start));
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}

	const counters = document.querySelectorAll('.wp-block-column .h2 strong em');
	counters.forEach(counter => {
		const value = parseInt(counter.textContent.replace(/,/g, ""));
		animateValue(counter, 0, value, 2000); // Adjust duration as needed
	});


	var heroBlock = document.querySelector('.wp-block-cover.hero');

	if (!heroBlock) {
		document.body.classList.add('has-no-hero');
	}

	//footnotes tooltip hover
	// Find all superscript footnote references
	var footnoteRefs = document.querySelectorAll('sup.fn a');

	footnoteRefs.forEach(function (fnRef) {
		// Prevent the default click action
		fnRef.addEventListener('click', function (e) {
			e.preventDefault();
		});

		// Get the ID from the href attribute of the anchor tag
		var fnId = fnRef.getAttribute('href').substring(1); // Remove the '#' character

		// Find the corresponding footnote content
		var footnoteContent = document.getElementById(fnId);
		if (footnoteContent) {
			// Set the title for the tooltip
			fnRef.parentNode.setAttribute('title', footnoteContent.innerText);

			// // Initialize the Bootstrap tooltip
			// new bootstrap.Tooltip(fnRef.parentNode, {
			// 	placement: 'top',
			// 	html: true,
			// 	trigger: 'hover focus'
			// });
		}
	});

	function scrollToElementWithOffset(targetId, offset = 110) {
		const targetElement = document.querySelector(targetId);
		if (targetElement) {
			window.scrollTo({
				top: targetElement.offsetTop - offset,
				behavior: 'smooth'
			});
		}
	}


	const anchorLinks = document.querySelectorAll('a[href^="#"]');

	anchorLinks.forEach(link => {
		link.addEventListener('click', function (e) {
			e.preventDefault();
			const targetId = this.getAttribute('href');
			scrollToElementWithOffset(targetId);
		});
	});

	if (window.location.hash) {
		scrollToElementWithOffset(window.location.hash, 110);
	}

	const videoButton = document.querySelector('.has-icon-video');
	const modalElement = document.getElementById('videoPopupModal');
	const videoPlaceholder = document.getElementById("videoPlaceholder");

	if (videoButton && modalElement && videoPlaceholder) {
		videoButton.addEventListener('click', function () {
			// You can store the video source in a data attribute of the button, e.g., data-video-src
			const videoSrc = this.getAttribute('data-video-src');

			// Check if videoSrc is not empty
			//if(videoSrc) {
			// Create video element with autoplay and muted attributes
			videoPlaceholder.innerHTML = '<div class="ratio ratio-16x9"><video class="embed-responsive-item" controls poster="/wp-content/uploads/2023/12/placeholder.jpg"><source src="/wp-content/uploads/video/fmcapromo.mp4" type="video/mp4"></video></div>';
			//}
		});

		modalElement.addEventListener('hidden.bs.modal', function () {
			// Clear the video content when the modal is closed
			videoPlaceholder.innerHTML = '';
		});
	} else {
		// console.error('Required elements are missing!');
	}

	// const categories = document.querySelectorAll('.wp-block-categories-list.blog-filter .cat-item');
	// const posts = document.querySelectorAll('.query-loop-block li');
	//
	// categories.forEach(cat => {
	// 	cat.addEventListener('click', function () {
	// 		const category = this.getAttribute('data-category');
	// 		posts.forEach(post => {
	// 			if (post.classList.contains(category)) {
	// 				post.style.display = '';
	// 			} else {
	// 				post.style.display = 'none';
	// 			}
	// 		});
	// 	});
	// });


	var offcanvas = document.querySelector('.offcanvas');
	var getHeader = document.querySelector('#wrapper-navbar');

	offcanvas.addEventListener('show.bs.offcanvas', function () {
		getHeader.classList.add('offcanvas-open');
	});

	offcanvas.addEventListener('hide.bs.offcanvas', function () {
		getHeader.classList.remove('offcanvas-open');
	});


	// function fetchPosts(category, paged = 1) {
	//     var data = new FormData();
	//     data.append('action', 'filter_posts');
	//     data.append('category', category);
	//     data.append('paged', paged);
	//
	//     fetch('/wp-admin/admin-ajax.php', {
	//         method: 'POST',
	//         body: data
	//     })
	//         .then(response => response.text())
	//         .then(response => {
	//             var parser = new DOMParser();
	//             var doc = parser.parseFromString(response, 'text/html');
	//             document.querySelector('.wp-block-query.past-blog-posts').innerHTML = response;
	//             document.querySelector('.wp-block-query-pagination').innerHTML = doc.querySelector('.wp-block-query-pagination').innerHTML;
	//             attachPaginationEventListeners();
	//         });
	//     attachPaginationEventListeners();
	// }

	var currentCategory = '';

	const fetchPosts = (category, paged = 1, isCategoryClick = false) => {
		const data = new FormData();
		data.append('action', 'filter_posts');
		data.append('category', category);
		data.append('paged', paged);

		fetch('/wp-admin/admin-ajax.php', {
			method: 'POST',
			body: data
		})
			.then(response => response.text())
			.then(response => {
				const parser = new DOMParser();
				const doc = parser.parseFromString(response, 'text/html');

				const postsContainer = document.querySelector('.wp-block-query.past-blog-posts');
				const paginationContainer = document.querySelector('.wp-block-query-pagination');

				if (postsContainer) {
					postsContainer.innerHTML = response;
				}

				// Replace pagination only if it's a category click
				if (isCategoryClick && paginationContainer && doc.querySelector('.wp-block-query-pagination')) {
					paginationContainer.innerHTML = doc.querySelector('.wp-block-query-pagination').innerHTML;
				}

				attachPaginationEventListeners();
			});
	};

	function attachPaginationEventListeners() {
		document.querySelectorAll('.wp-block-query-pagination a').forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				var page = this.getAttribute('href').split('query-0-page=')[1];
				if (!page) {
					page = 1; // Default to page 1 if not found
				}
				fetchPosts(currentCategory, page);
			});
		});
	}


	document.querySelectorAll('.wp-block-categories-list .cat-item a').forEach(link => {
		link.addEventListener('click', function (e) {
			e.preventDefault();
			currentCategory = this.parentNode.getAttribute('data-category');
			fetchPosts(currentCategory, 1, true); // Category click
		});
	});

	function moveTOC() {
		// get the necessary elements
		const toc = document.getElementById('toc');
		const content = document.querySelector('.single-content');
		const contentParent = document.querySelector('.content-sidebar-wrapper');

		if (window.innerWidth < 992) {
			if (toc) {
				// If viewport width is less than 992px and TOC exists, move it before content
				contentParent.insertBefore(toc, content);
			}
		} else {
			if (toc) {
				// If viewport width is at least 992px, and TOC exists, move it back to sidebar
				const sidebar = document.querySelector('.sidebar .has-sticky');
				sidebar.insertBefore(toc, sidebar.firstChild);
			}
		}
	}

	function toggleTOCVisibility() {
		const toc = document.getElementById('toc');

		// Check if the 'toc' element exists
		if (!toc) {
			// console.warn("Element with ID 'toc' not found");
			return;
		}

		const tocTitle = toc.querySelector('.sidebar-title');
		const tocIcon = toc.querySelector('.fa-chevron-down, .fa-chevron-up'); // Adjust the selector as necessary

		// Check if the 'tocTitle' and 'tocIcon' elements exist
		if (!tocTitle || !tocIcon) {
			// console.warn("One of the required elements ('.sidebar-title', '.fa-chevron-down, .fa-chevron-up') not found in the 'toc' container");
			return;
		}

		tocTitle.addEventListener('click', function () {
			toc.classList.toggle('is-active'); // Toggle visibility class

			// Check if the TOC is active and toggle the icon class accordingly
			if (toc.classList.contains('is-active')) {
				tocIcon.classList.remove('fa-chevron-down');
				tocIcon.classList.add('fa-chevron-up');
			} else {
				tocIcon.classList.remove('fa-chevron-up');
				tocIcon.classList.add('fa-chevron-down');
			}
		});
	}


// Execute moveTOC initially and on window resize
	moveTOC();
	toggleTOCVisibility();
	window.addEventListener('resize', moveTOC);


});
